import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

import QuizService from '../../QuizService'

import {
  ADD_QUIZ,
  GET_QUIZ,
  DELETE_QUIZ,
  GET_QUIZZES,
  EDIT_QUIZ,
  RESET_QUIZ,
  RESET_ADD_QUIZ_SUCCESS,
  RESET_EDIT_QUIZ_SUCCESS,
} from './quiz.actionTypes'

import { getNewPageOnDelete } from '../../../helpers'

import { defaultErrorMessage } from '../../../constants'

export const getQuizzes = createAsyncThunk(GET_QUIZZES, async (data) => {
  try {
    const response = await QuizService.getQuizzes(data.page)

    if (response.data?.error) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const getQuiz = createAsyncThunk(GET_QUIZ, async (data) => {
  try {
    const response = await QuizService.getQuiz(data)

    if (response.data?.error) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const addQuiz = createAsyncThunk(ADD_QUIZ, async (data, { dispatch }) => {
  try {
    const response = await QuizService.addQuiz(data)

    if (response.data?.error) {
      if (typeof response.data.error === 'object') {
        const errorMessage = Object.values(response.data.error)
          .map((error) => error.toString())
          .join(', ')
        throw new Error(errorMessage)
      }

      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    dispatch(
      getQuizzes({
        page: 1,
      })
    )

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const editQuiz = createAsyncThunk(EDIT_QUIZ, async (data) => {
  try {
    const response = await QuizService.editQuiz(data.id, data.data)

    if (response.data?.error) {
      if (typeof response.data.error === 'object') {
        const errorMessage = Object.values(response.data.error)
          .map((error) => error.toString())
          .join(', ')
        throw new Error(errorMessage)
      }

      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const deleteQuiz = createAsyncThunk(DELETE_QUIZ, async (data, { getState, dispatch }) => {
  try {
    const response = await QuizService.deleteQuiz(data)

    if (response.data?.error) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    const { quizzesPage, quizzes } = getState().quiz

    await dispatch(
      getQuizzes({
        page: getNewPageOnDelete(quizzesPage, quizzes.length),
      })
    )
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const resetQuiz = createAction(RESET_QUIZ)

export const resetAddQuizSuccess = createAction(RESET_ADD_QUIZ_SUCCESS)
export const resetEditQuizSuccess = createAction(RESET_EDIT_QUIZ_SUCCESS)
